'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import { connect } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
import ResultItem from 'DesignFinderUI/components/results/ResultItem';
import UILink from 'UIComponents/link/UILink';
import * as FoldersActions from 'DesignData/actions/finder/Folders';
import * as Selections from 'DesignData/actions/finder/Selections';
import { getIsThemeRootFolder } from 'DesignData/selectors/finder';
import { DEFAULT_FOLDER_ICON, THEME_FOLDER_ICON } from 'DesignData/constants/Icons';

const i18nKey = key => `DesignFinderUI.results.AssetResultItem.${key}`;

class FolderResultItem extends Component {
  constructor(...args) {
    super(...args);

    this.onClick = () => {
      const {
        id,
        openFolder,
        revealInFinder,
        onClose
      } = this.props;
      openFolder(id);
      revealInFinder(id);
      setTimeout(onClose);
    };
  }

  render() {
    const _this$props = this.props,
          {
      folderPath: __folderPath,
      __name
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["folderPath", "__name"]);

    const name = /*#__PURE__*/_jsx(UILink, {
      onClick: this.onClick,
      use: "unstyled",
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: __name
      })
    });

    const folderPath = __folderPath ? /*#__PURE__*/_jsx(UITruncateString, {
      tooltip: __folderPath,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: i18nKey('folderPath'),
        options: {
          folderPath: __folderPath
        }
      })
    }) : null;
    const icon = this.props.isThemeFolder ? THEME_FOLDER_ICON : DEFAULT_FOLDER_ICON;
    return /*#__PURE__*/_jsx(ResultItem, Object.assign({}, rest, {
      help: folderPath,
      icon: icon,
      title: name
    }));
  }

}

FolderResultItem.propTypes = {
  folderPath: PropTypes.string,
  id: FolderPropTypes.folderId.isRequired,
  __name: PropTypes.string.isRequired,
  openFolder: PropTypes.func.isRequired,
  revealInFinder: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  isThemeFolder: PropTypes.bool.isRequired
};
FolderResultItem.defaultProps = {
  onClose: emptyFunction,
  folderPath: ''
};

function mapStateToProps(state, props) {
  props = Object.assign({}, props, {
    folderId: props.id
  });
  return {
    isThemeFolder: getIsThemeRootFolder(state, props)
  };
}

const mapDispatchToProps = {
  openFolder: FoldersActions.openDeeplyNestedFolder,
  revealInFinder: Selections.revealInFinder
};
export default connect(mapStateToProps, mapDispatchToProps)(FolderResultItem);